import { observer } from "mobx-react";
import React from 'react';
import styles from "./index.module.scss";
import { useTranslation } from 'react-i18next';

const PolyDogeCardsDescription = observer(() => {
    const { t } = useTranslation();
    const priceArray = t("nft_description.purchase_description_1_prices", { returnObjects: true });

    return (
        <div id="polydoge-cards-description" name="polydoge-cards-description" className={styles["description-row"]}>
            <div className={styles["description-container"]}>
                <div className={styles["block"]} data-aos="zoom-in">
                    <h2>{t("nft_description.reward_title1")}</h2>
                    <div className={styles["column"]}>
                        <p>{t("nft_description.reward_description1")}</p>
                    </div>
                </div>
                <div className={styles["block"]} data-aos="zoom-in">
                    <img alt={"PolyDoge Cards Hero"} src={"images/pd-cards-5row.png"} />
                </div>
                <div className={styles["block"]} data-aos="zoom-in">
                    <h2>{t("nft_description.reward_title2")}</h2>
                    <div className={styles["column"]}>
                        <p>{t("nft_description.reward_description2")}</p>
                    </div>
                    <p className={styles["reward3"]}>{t("nft_description.reward_description3")}</p>
                </div>
                <div className={styles["block"]} data-aos="zoom-in">
                    <h2>{t("nft_description.purchase_title")}</h2>
                    <ul>
                        {priceArray.map((item, i) => {
                            return <li key={i}>#{item}</li>
                        })}
                    </ul>
                    <p>{t("nft_description.purchase_description_2")}</p>
                    <p>{t("nft_description.purchase_description_3")}</p>
                </div>

            </div>
        </div>
    )
});

export default PolyDogeCardsDescription;
